import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Undo = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Undo" {...props}>
    <path d="M6.5577 3.96891C6.95048 3.64828 7.53035 3.67105 7.89657 4.03727C8.28666 4.42775 8.28676 5.06091 7.89657 5.45133L5.34677 8.00016H16.0391C17.2705 8.00018 18.4718 8.38155 19.4776 9.09195C22.8394 11.4667 22.8395 16.4536 19.4776 18.8283C18.4718 19.5387 17.2705 19.9201 16.0391 19.9201H14.0411L13.9386 19.9152C13.4343 19.8641 13.0412 19.4378 13.0411 18.9201C13.0411 18.4022 13.4342 17.9761 13.9386 17.925L14.0411 17.9201H16.0391C16.8572 17.9201 17.6551 17.6664 18.3233 17.1945C20.557 15.6167 20.5569 12.3036 18.3233 10.7257C17.6551 10.2538 16.8572 10.0002 16.0391 10.0002H5.37313L7.89657 12.5226C8.28664 12.9131 8.28678 13.5463 7.89657 13.9367C7.53041 14.3028 6.95047 14.3255 6.5577 14.005L6.48153 13.9367L2.33114 9.78629C1.88985 9.345 1.88987 8.62895 2.33114 8.18766L6.48153 4.03727L6.5577 3.96891Z" fill="#000" />
  </StyledIcon>
));

Undo.displayName = 'Undo';

export { Undo };
